export default "__VITE_ASSET__CF33B7sT__"